import { z } from 'zod';

export const NetworkIdParamsSchema = z.object({
  networkId: z.uuid(),
});

export type NetworkIdParams = z.infer<typeof NetworkIdParamsSchema>;

export const GetNetworkResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type GetNetworkResponse = z.infer<typeof GetNetworkResponseSchema>;
